import React, { useEffect } from 'react'
import { Combobox } from 'react-widgets'
import SetupData from '../../data/setupData'

const FilterBar = (props) => {
    const setYear = (value) => {
        props.setYear(value)
    }

    const setSelectedBranch = (value) => {
        props.setHierLevel(0)
        props.setSelectedBranch(value)
    }

    const setSelectedGroup = (value) => {
        props.setHierLevel(0)
        props.setHierLevelList(null)
        props.setSelectedGroup(value)
    }

    const goToHead = () => {
        props.goToHead()
    }

    const handleChange = (val) => {
        props.handleChange(val)
    }

    const handleSelect = (val) => {
        props.handleSelect(val)
    }

    const setOneLevelOnly = (bools) => {
        props.setOneLevelOnly(bools)
    }

    const setShowPayout = (bools) => {
        props.setShowPayout(bools)
    }

    const setShowCommission = (bools) => {
        props.setShowCommission(bools)
    }

    const handleSelectHier = (val) => {
        props.setHierLevel(val.id)
    }

    const setUserStatus = (val) => {
        // console.log(val)
        props.setUserStatus(val)
    }

    return (
        <div className='w-full py-2 px-4 bg-white flex xl:flex-row flex-col justify-between xl:items-center relative z-30 shadow gap-1'>
            <div className='flex md:flex-nowrap flex-wrap items-center gap-1'>
                {props.branches?.length > 0 && <div className="md:w-40 md:flex-none flex-1">
                    <select onChange={e => setSelectedBranch(e.target.value)} className="w-full py-2 px-3 rounded-md border border-border text-sm text-gray-two cursor-pointer focus-visible:outline-none appearance-none bg-white" aria-label="Default select example">
                        <option key="allBranches" value="">All Branches</option>
                        {props.branches?.map(item => {
                            return <option key={item.branch} value={item.branch} >{item.branch}</option>
                        })}
                    </select>
                </div>}

                {props.selectedBranch && props.groups?.length > 0 && <div className="md:w-40 md:flex-none flex-1">
                    <select onChange={e => setSelectedGroup(e.target.value)} className="w-full py-2 px-3 rounded-md border border-border text-sm text-gray-two cursor-pointer focus-visible:outline-none appearance-none bg-white" aria-label="Default select example">
                        <option key="allGroups" value="">All Groups</option>
                        {props.groups.map(group => {
                            return <option key={group} value={group} >{group}</option>
                        })}
                    </select>
                </div>}

                {
                    props.allowToSeePayout && props.selectedGroup && props.hierLevelList?.length > 1 &&
                    <div className='flex md:flex-none flex-1 gap-1'>
                        <div className='md:w-40 md:flex-none flex-1'>
                            <Combobox
                                className="level-box"
                                data={props.hierLevelList}
                                defaultValue={props.hierLevel}
                                dataKey='id'
                                textField='name'
                                onSelect={handleSelectHier}
                                filter='contains'
                            />
                        </div>
                        {
                            props.hierLevel > 0 &&
                            <button onClick={() => props.setOpenHierSuggestion(!props.openHierSuggestion)} disabled={props.hierSuggestion.length === 0} className='rounded-md border border-border h-[38px] w-[38px] flex items-center justify-center text-sm transition hover:bg-secondary-light text-gray-two focus-within:outline-none disabled:bg-secondary-light'>
                                {
                                    props.openHierSuggestion ?
                                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="w-5 h-5">
                                            <path strokeLinecap="round" strokeLinejoin="round" d="M3 4.5h14.25M3 9h9.75M3 13.5h5.25m5.25-.75L17.25 9m0 0L21 12.75M17.25 9v12" />
                                        </svg> :
                                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="w-5 h-5">
                                            <path strokeLinecap="round" strokeLinejoin="round" d="M3 4.5h14.25M3 9h9.75M3 13.5h9.75m4.5-4.5v12m0 0l-3.75-3.75M17.25 21L21 17.25" />
                                        </svg>
                                }
                            </button>
                        }
                    </div>
                }

                {
                    props.hierLevel === 0 &&
                    <div className='md:w-80 w-full'>
                        <Combobox
                            className="search-box"
                            data={props.suggestion}
                            busy={props.busy}
                            hideCaret
                            placeholder={`Search agent here`}
                            dataKey='_id'
                            textField='UserNameWithBranchAndGroup'
                            onChange={handleChange}
                            onSelect={handleSelect}
                            filter='contains'
                        />
                    </div>
                }
            </div>

            <div className='flex md:flex-nowrap flex-wrap items-center md:gap-2 gap-1'>
                <div className='flex md:flex-nowrap flex-wrap items-center gap-1'>
                    <button type="button" onClick={() => setShowCommission(!props.showCommission)} className={'py-2 px-3 md:flex-none flex-1 whitespace-nowrap rounded-md border border-primary text-sm text-primary cursor-pointer focus-visible:outline-none ' + (props.showCommission && 'bg-primary-light')}>Commission</button>
                    {
                        props.allowToSeePayout &&
                        <button type="button" onClick={() => setShowPayout(!props.showPayout)} className={'py-2 px-3 md:flex-none flex-1 whitespace-nowrap rounded-md border border-success text-sm text-success cursor-pointer focus-visible:outline-none ' + (props.showPayout && 'bg-success-light')}>Payout</button>
                    }
                    <button type="button" onClick={() => setOneLevelOnly(!props.oneLevelOnly)} className={'py-2 px-3 md:flex-none flex-1 whitespace-nowrap rounded-md border border-slate-500 text-sm text-slate-500 cursor-pointer focus-visible:outline-none ' + (!props.oneLevelOnly && 'bg-secondary-light')}>1 Level</button>
                    {/* <button type="button" onClick={() => setUserStatus(!props.showSuspended)} className={'py-2 px-3 md:flex-none flex-1 whitespace-nowrap rounded-md border border-danger text-sm text-danger cursor-pointer focus-visible:outline-none ' + (props.showSuspended && 'bg-red-50')}>Show Suspended</button> */}
                    <div className='md:w-[auto] w-full'>
                        <select onChange={e => setUserStatus(e.target.value)} value={props.userStatus} className="w-full py-2 px-3 rounded-md border border-border text-sm text-gray-two cursor-pointer focus-visible:outline-none appearance-none bg-white" aria-label="Default select example">
                            {SetupData.userStatus?.map(obj => {
                                return (
                                    <option key={obj.label} value={obj.value} disabled={obj.value === "User Status"} style={{ color: obj.value === "User Status" && "#999" }}
                                    >{obj.label}
                                    </option>)
                            })}
                        </select>
                    </div>
                </div>

                <div className='md:w-[84px] w-full'>
                    <select onChange={e => setYear(e.target.value)} value={props.year} className="w-full py-2 px-3 rounded-md border border-border text-sm text-gray-two cursor-pointer focus-visible:outline-none appearance-none bg-white" aria-label="Default select example">
                        {props.listOfYear?.map(group => {
                            return <option key={group} value={group} >{group}</option>
                        })}
                    </select>
                </div>
            </div>
        </div>
    )
}

export default FilterBar